import API from '@/api';

const GET_DATA = 'GET_DATA';
const GET_DATA_FAILED = 'GET_DATA_FAILED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const SET_AGREEMENT_LIST = 'SET_AGREEMENT_LIST';
const SET_CURRENT_AGREEMENT = 'SET_CURRENT_AGREEMENT';

// Enabled the module to be namespaced
const namespaced = true;

const state = {
  loading: false,
  agreementList: [],
  currentAgreement: null,
};

const markLatestVersionPerType = (agreements) => {
  if (!Array.isArray(agreements)) return [];

  const latestDateByType = {};

  agreements.forEach((agreement) => {
    const { type } = agreement || {};
    const createdAt = new Date(agreement?.created_at || 0).getTime();

    if (!type) return;

    if (latestDateByType[type] === undefined || createdAt > latestDateByType[type]) {
      latestDateByType[type] = createdAt;
    }
  });

  return agreements.map((agreement) => {
    const { type } = agreement || {};
    const createdAt = new Date(agreement?.created_at || 0).getTime();
    const latestForType = type ? latestDateByType[type] : undefined;

    const isLatest = latestForType !== undefined && createdAt === latestForType;

    return {
      ...agreement,
      current_version: isLatest,
    };
  });
};

const getters = {
  isLoading: (state) => {
    return state.loading;
  },

  agreementList: (state) => {
    return (
      state.agreementList?.sort((a, b) => {
        const dateA = new Date(a.created_at || 0);
        const dateB = new Date(b.created_at || 0);
        return dateB - dateA;
      }) || []
    );
  },

  currentAgreement: (state) => {
    return state.currentAgreement;
  },
};

const actions = {
  // * Get all Legal Agreements
  async getLegalAgreementsList({ commit }) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.legalAgreements.getLegalAgreementsList();
      console.log('response:', response);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        const agreementsWithCurrentVersion = markLatestVersionPerType(response.data);
        commit(SET_AGREEMENT_LIST, agreementsWithCurrentVersion);
        commit(GET_DATA_SUCCESS);
        resolve(agreementsWithCurrentVersion);
      }
    });
  },

  // * Get single AI Commentary config by ID
  async getLegalAgreement({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.legalAgreements.getLegalAgreement(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(SET_CURRENT_AGREEMENT, response.data);
        commit(GET_DATA_SUCCESS);
        resolve(response.data);
      }
    });
  },

  // * Create new Legal Agreement
  async createLegalAgreement({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.legalAgreements.createLegalAgreement(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        // commit(SET_CURRENT_AGREEMENT, response.data);
        commit(GET_DATA_SUCCESS);
        resolve(response.data);
      }
    });
  },

  // * Update existing Legal Agreement
  async updateLegalAgreement({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.legalAgreements.updateLegalAgreement(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(SET_CURRENT_AGREEMENT, response.data);
        commit(GET_DATA_SUCCESS);
        resolve(response.data);
      }
    });
  },

  // * Delete Legal Agreement
  async deleteLegalAgreement({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.legalAgreements.deleteLegalAgreement(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS);
        resolve(response.data);
      }
    });
  },

  // // * Clear current agreement (useful when navigating away)
  // clearCurrentAgreement({ commit }) {
  //   commit(CLEAR_CURRENT_AGREEMENT);
  // },
};

// @ MUTATIONS ====================================================================
const mutations = {
  [GET_DATA](state) {
    state.loading = true;
  },

  [GET_DATA_FAILED](state) {
    state.loading = false;
  },

  [GET_DATA_SUCCESS](state) {
    state.loading = false;
  },

  [SET_AGREEMENT_LIST](state, data) {
    state.agreementList = data;
  },

  [SET_CURRENT_AGREEMENT](state, data) {
    state.currentAgreement = data;
  },

  // [CLEAR_CURRENT_AGREEMENT](state) {
  //   state.currentAgreement = null;
  // },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
